const normalizeRoutePath = (path: string): string => path.replace(/^\//, '').replace(/\/$/, '');

const limitedCompanyAllowedRoutePatterns: RegExp[] = [
  /^dashboard$/,
  /^planning\/shifts(\/.*)?$/,
  /^checkout\/inbox(\?.*)?$/,
  /^checkout\/archive(\?.*)?$/,
  /^management\/users(\/.*)?$/,
  /^unauthorized$/,
];

const sidebarPathToRoutePath = (sidebarPath: string): string => sidebarPath.replace(/\/\*$/, '');

export const isOgpRouteAllowedForLimitedCompany = (routePath: string): boolean => {
  const normalized = normalizeRoutePath(routePath.split('?')[0] ?? routePath);
  return limitedCompanyAllowedRoutePatterns.some((pattern) => pattern.test(normalized));
};

export const isOgpSidebarPathAllowedForLimitedCompany = (sidebarPath: string): boolean =>
  isOgpRouteAllowedForLimitedCompany(sidebarPathToRoutePath(sidebarPath));

export const limitedCompanyDefaultFallbackPath = 'planning/shifts';
